import Cookies from 'js-cookie';
import {COOKIES} from '@util/StorageUtils';
import {setContext} from 'apollo-link-context';

const authLink = setContext( ( _, {headers} ) => {
    const TOKEN = Cookies.get( COOKIES.AUTH_TOKEN.name );
    const authHeader = TOKEN ? {authorization: `Bearer ${TOKEN}`} : {};
    return {
        headers: {
            ...headers,
            ...authHeader
        }
    };
} );

export default authLink;
